export const CheckCircleIcon = ({ className }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2047_122429)">
        <path
          d="M8.55469 13.3164L10.8047 15.5664L16.0547 10.3164"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.3047 21.5664C17.2753 21.5664 21.3047 17.537 21.3047 12.5664C21.3047 7.59584 17.2753 3.56641 12.3047 3.56641C7.33412 3.56641 3.30469 7.59584 3.30469 12.5664C3.30469 17.537 7.33412 21.5664 12.3047 21.5664Z"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2047_122429">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.304688 0.566406)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
